import { GlAlert, GlLoadingIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import eventHub from '~/blob/components/eventhub';
import { SNIPPET_MARK_VIEW_APP_START, SNIPPET_MEASURE_BLOBS_CONTENT } from '~/performance/constants';
import { performanceMarkAndMeasure } from '~/performance/utils';
import { getSnippetMixin } from '../mixins/snippets.js?vue3';
import { markBlobPerformance } from '../utils/blob';
import SnippetBlob from './snippet_blob_view.vue?vue3';
import SnippetHeader from './snippet_header.vue?vue3';
import SnippetDescription from './snippet_description.vue?vue3';
eventHub.$on(SNIPPET_MEASURE_BLOBS_CONTENT, markBlobPerformance);
export default {
    name: 'SnippetsShow',
    components: {
        SnippetHeader,
        SnippetDescription,
        GlAlert,
        GlLoadingIcon,
        SnippetBlob
    },
    mixins: [
        getSnippetMixin
    ],
    computed: {
        hasUnretrievableBlobs () {
            return this.snippet.hasUnretrievableBlobs;
        },
        hasLoadError () {
            return this.snippetLoadError || !this.isLoading && !this.snippet.id;
        }
    },
    beforeCreate () {
        performanceMarkAndMeasure({
            mark: SNIPPET_MARK_VIEW_APP_START
        });
    }
};
